import { CheckIcon } from '@heroicons/react/20/solid';
import type { StepperStep } from '@library/types/utils';
import { classNames } from '@library/utils';

// navigationSteps
export interface StepperProps {
  children?: React.ReactNode;
  steps: Array<StepperStep>;
}

export const Stepper = ({ children = '', steps }: StepperProps) => {
  return (
    <div className="p-4">
      <nav aria-label="Progress" className="m-auto w-full max-w-4xl px-4">
        <div className="flex w-full items-center">
          {steps.map((step) => {
            const { name, idx } = step;
            const lastStep = step.idx === steps.length;
            const isComplete = step.status === 'complete';
            const isCurrent = step.status === 'current';

            return (
              <div
                className={classNames(
                  'flex flex-col pb-4',
                  lastStep ? '' : 'grow'
                )}
                key={`${idx}-${name}`}
              >
                <div className="flex items-center">
                  <div
                    className={classNames(
                      'flex size-16 flex-col items-center justify-center gap-1'
                    )}
                  >
                    <div
                      className={classNames(
                        'text-soFresh-100 flex h-8 w-8 flex-none items-center justify-center rounded-full',
                        isComplete || isCurrent
                          ? 'bg-soClean-100'
                          : 'bg-soFresh-130'
                      )}
                    >
                      <CheckIcon
                        className="text-soFresh-100 size-5 font-bold"
                        aria-hidden="true"
                      />
                    </div>

                    <span
                      className={classNames(
                        'text-soClean-100 text-sm',
                        isCurrent ? 'font-bold' : '',
                        isComplete ? 'text-soClean-180' : ''
                      )}
                    >
                      {step.name}
                    </span>
                  </div>
                  {!lastStep && (
                    <div
                      className={classNames(
                        'mx-2 h-2 grow rounded-md',
                        isComplete ? 'bg-soClean-100' : 'bg-soFresh-130'
                      )}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </nav>
      {children}
    </div>
  );
};
